var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-container"},[_c('el-container',{staticClass:"home-container"},[_c('el-container',{staticClass:"in-container page-content-margin-sm-and-up"},[_c('el-header',[_c('v-header',{on:{"click":_vm.handleClick}})],1),_c('el-main',[_c('div',{staticClass:"quoting-page flex-1 flex-col"},[_c('router-view')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }